var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { staticImplements } from '../interfaces/IQueryParser.js';
import { Shape } from '../shapes/Shape.js';
import { LinkedStorage } from '../utils/LinkedStorage.js';
import { UpdateQueryFactory } from './UpdateQuery.js';
import { CreateQueryFactory } from './CreateQuery.js';
import { DeleteQueryFactory } from './DeleteQuery.js';
let QueryParser = class QueryParser {
    static selectQuery(query) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const queryObject = query.getQueryObject();
                return LinkedStorage.selectQuery(queryObject);
            }
            catch (e) {
                return Promise.reject(e);
            }
        });
    }
    static updateQuery(id, updateObjectOrFn, shapeClass) {
        const query = new UpdateQueryFactory(shapeClass, id, updateObjectOrFn);
        let queryObject = query.getQueryObject();
        return LinkedStorage.updateQuery(queryObject);
    }
    static createQuery(updateObjectOrFn, shapeClass) {
        try {
            const query = new CreateQueryFactory(shapeClass, updateObjectOrFn);
            let queryObject = query.getQueryObject();
            return LinkedStorage.createQuery(queryObject);
        }
        catch (e) {
            console.warn(e);
        }
    }
    static deleteQuery(id, shapeClass) {
        const query = new DeleteQueryFactory(shapeClass, id);
        let queryObject = query.getQueryObject();
        return LinkedStorage.deleteQuery(queryObject);
    }
};
QueryParser = __decorate([
    staticImplements() /* this class implements this interface with static methods */
], QueryParser);
export { QueryParser };
Shape.queryParser = QueryParser;
//# sourceMappingURL=QueryParser.js.map